document.addEventListener('algolia.hooks.initialize', function() {

  if ($('.productgrid--sidebar-section').length) {
    console.log($('.productgrid--sidebar-section').length);
    setTimeout(function(){
    $('.productgrid--sidebar-section').insertBefore($('.ais-facet-named_tags'));
      $('.productgrid--sidebar-section').show();
    }, 500);
  }

  algoliaShopify.hooks.registerHook("beforeAutocompleteProductTemplate", function (_defaultTemplate, templateOptions, distinct, itemLink) {
      // Modify default options, then return them
      const { html, item, components } = templateOptions;
      return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${(event) => handleItemClick(event, item)}"
    >
      <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img
            src="${algoliaShopify.helpers.compactImage(item)}"
            alt="${item.title}"
          />
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentBrand">
            ${item.vendor &&
              html`
                <span> ${algoliaShopify.translations.by} </span>
              `}
            ${item.vendor && components.Highlight({ attribute: 'vendor', hit:item })}
          </div>
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
               ${item.meta.smallflower.product_title}
              <span class="algolia-variant">
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
            </div>
          </div>
          <div class="aa-ItemContentPrice">
            <div class="aa-ItemContentPriceCurrent">
              ${algoliaShopify.helpers.displayPrice(item, distinct)}
            </div>
          </div>
        </div>
      </div>
    </a>
  `;
    });
 
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    return html`
      <div class="ais-page ais-search-page">
        <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        
        <div class="ais-facets-button">
          Show filters
        </div>
        <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
        <div class="ais-facets">
        <div id="sort-by"></div>
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          <div  class="ais-facet-dropdown-wrapper ais-facet-disjunctive ais-facet-named_tags">
           <label for="named_tags" class="ais-range-slider--header ais-facet--header ais-header">Category</label>
           <input class="ais-dropdown-checkbox" type="checkbox" id="named_tags" name="dropdown" />
            <div class="ais-facet-named_tags-container ais-facet-dropdown-container">
              <div id="aa-hierarchical-menu"></div>
            </div>
          </div>
          ${data.facets.map(
            facet =>
              html`
                <div
                  class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                >
                  <label
                    for="${facet.escapedName}"
                    class="ais-range-slider--header ais-facet--header ais-header"
                    >${facet.title}</label
                  >
                  <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                  />
                  <div
                    class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                  ></div>
                </div>
              `
          )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container">
        </div>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components, handleItemClick) {
  let isBestSeller = false;
  let isSoldOut = hit.inventory_quantity <= 0 && !hit.available; // Sold out condition
  let hasDiscount = hit.compare_at_price > hit.price; // Discount condition

  // Calculate the percentage saved if there's a discount
  let discountPercentage = 0;
  if (hasDiscount) {
    discountPercentage = Math.round(((hit.compare_at_price - hit.price) / hit.compare_at_price) * 100);
  }

  // Check if hit.tags exists and is an array
  if (Array.isArray(hit.tags)) {
    for (let i = 0; i < hit.tags.length; i++) {
      if (hit.tags[i] === "Best Seller") {
        isBestSeller = true;
        break; // Exit loop once the tag is found
      }
    }
  }

  return html`
    <div
      class="ais-hit ais-product"
      data-algolia-index="${hit.index}"
      data-algolia-position="${hit.productPosition}"
      data-algolia-queryid="${hit.queryID}"
      data-algolia-objectid="${hit.objectID}"
      data-handle="${hit.handle}"
      data-variant-id="${hit.objectID}"
      data-distinct="${hit._distinct}"
      data-product-id="${hit.id}"
      onClick="${(event) => handleItemClick(event, hit)}"
    >
      <img
        class="ais-hit--picture"
        src="${algoliaShopify.helpers.mediumImage(hit)}"
        alt="${hit.title} - ${hit.variant_title}"
      />

      ${isBestSeller &&
        html`
          <div class="product__itemlabel best-seller">
            <p class="ais-hit--tags">
              <img src="https://cdn.shopify.com/s/files/1/0418/0662/6967/files/best-seller_50x.png" srcset="https://cdn.shopify.com/s/files/1/0418/0662/6967/files/best-seller_100x.png 2x" loading="lazy"/>
            </p>
          </div>
        `
      }

      ${hasDiscount &&
        html`
          <div class="product__itemlabel discount">
            <span class="discount-percentage">Save ${discountPercentage}%</span>
          </div>
        `
      }

      ${isSoldOut && !hasDiscount &&
        html`
          <div class="product__itemlabel sold-out">
            <span class="sold-out-text">Sold Out</span>
          </div>
        `
      }

      <div class="ais-hit--details">
        <div class="product__vendor">${hit.vendor}</div>
        <p class="ais-hit--title">
          <a
            data-algolia-index="${hit.index}"
            data-algolia-position="${hit.productPosition}"
            data-algolia-queryid="${hit.queryID}"
            data-algolia-objectid="${hit.objectID}"
            href="${algoliaShopify.helpers.instantsearchLink(hit)}"
            onclick="void(0)"
            title="${algoliaShopify.helpers.fullTitle(
              productTitle,
              hit._distinct,
              hit.variant_title
            )}"
          >
            ${productTitle}
          </a>
        </p>
        
        <!-- Check if the product is sold out -->
        ${isSoldOut
          ? html`
            <p class="ais-hit--price out-of-stock-text">
              Out of stock
            </p>
          `
          : html`
            <p class="ais-hit--price">
              <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>
              ${hasDiscount &&
                html`
                  <span class="ais-hit--price-striked">
                    <span>${algoliaShopify.helpers.displayStrikedPrice(hit.price, hit.compare_at_price)}</span>
                  </span>
                `
              }
              ${hasDiscount &&
                html`
                  <span class="ais-hit--price-discount">
                    Save ${discountPercentage}%!
                  </span>
                `
              }
            </p>
          `
        }

        <p class="product__review" itemprop="aggregateRating" itemtype="https://schema.org/AggregateRating" itemscope="itemscope">
          <span class="Stars" style="--rating: ${hit.meta.yotpo.reviews_average}" aria-label="Rating of this product is ${hit.meta.yotpo.reviews_average} out of 5.">
            <span class="StarRating_Value" itemprop="ratingValue">${hit.meta.yotpo.reviews_average}/5</span>
          </span>
          <span class="reviewCount">
            <span itemprop="reviewCount">(${hit.meta.yotpo.reviews_count})</span>
          </span>
        </p>
      </div>
    </div>
  `;
});
 
  algoliaShopify.hooks.registerHook('afterISStartRemoveDefaultWidget', function(defaultWidgets) {
    const hitsWidget = defaultWidgets.find(
       widget => widget.$$widgetType === 'ais.hits'
      );
    
    // Find and return the default pagination widget
    const defaultPaginationWidget = defaultWidgets.find(
      widget => widget.$$widgetType === 'ais.pagination'
    );

    return [hitsWidget, defaultPaginationWidget];
  });

  algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function() {
    const { infiniteHits, sortBy, hierarchicalMenu } = window.instantsearch.widgets;
    const { connectSortBy, connectInfiniteHits } = instantsearch.connectors;
     // Create the render function
    const renderSortBy = (renderOptions, isFirstRender) => {
        const {
          options,
          currentRefinement,
          refine,
          widgetParams,
          // `canRefine` is only available from v4.45.0
          // Use `hasNoResults` in earlier minor versions.
          canRefine,
        } = renderOptions;
      
        if (isFirstRender) {
          const select = document.createElement('select');
      
          select.addEventListener('change', event => {
            refine(event.target.value);
          });
      
          widgetParams.container.appendChild(select);
        }
      
        const select = widgetParams.container.querySelector('select');
        select.classList.add("ais-SortBy-select");
      
        select.disabled = !canRefine;
      
        select.innerHTML = `
          ${options
            .map(
              option => `
                <option
                  value="${option.value}"
                  ${option.value === currentRefinement ? 'selected' : ''}
                  class="ais-SortBy-option"
                >
                  ${option.label}
                </option>
              `
            )
            .join('')}
        `;
      };
    
    // Create the custom widget
    const customSortBy = connectSortBy(renderSortBy);

    const sortBY = customSortBy({
        container: document.querySelector('#sort-by'),
        items: [
          { label: 'Best Sellers', value: 'shopify_products_recently_ordered_count_desc' },
          { label: 'New Arrivals', value: 'shopify_products_published_at_desc' },
          { label: 'Price (asc)', value: 'shopify_products_price_asc' },
          { label: 'Price (desc)', value: 'shopify_products_price_desc' },
          { label: 'Sale', value: 'shopify_products_sale' },
          { label: 'A-Z', value: 'products_metafield_title_asc' },
          { label: 'Customer Rating', value: 'shopify_products_customer_rating_desc' },
        ],
        transformItems(items) {
            return items.map(item => ({
              ...item,
              label: item.label.toUpperCase(),
            }));
          }
      });

    let lastRenderArgs;

   const renderInfiniteHits = (renderArgs, isFirstRender) => {
  const { items, hits, showMore, widgetParams } = renderArgs;
  const { container } = widgetParams;

  lastRenderArgs = renderArgs;

  if (isFirstRender) {
    const sentinel = document.createElement('div');
    const previousButton = document.createElement('button');
    previousButton.className = 'ais-InfiniteHits-loadMore';
    previousButton.textContent = 'Show More';

    const productList = document.createElement('ol');
    productList.className = 'ais-InfiniteHits-list';

    container.appendChild(productList);
    sentinel.appendChild(previousButton);
    container.appendChild(sentinel);

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !lastRenderArgs.isLastPage) {
          showMore();
        }
        if (lastRenderArgs.isLastPage) {
          container.querySelector('.ais-InfiniteHits-loadMore').classList.add('ais-InfiniteHits-loadMore--disabled');
        } else {
          container.querySelector('.ais-InfiniteHits-loadMore').classList.remove('ais-InfiniteHits-loadMore--disabled');
        }
      });
    });

    observer.observe(sentinel);
    return;
  }

  const remainingHits = hits.length;
  const showMoreButton = container.querySelector('.ais-InfiniteHits-loadMore');
  if (remainingHits < 24) {
    showMoreButton.classList.add('ais-InfiniteHits-loadMore--disabled');
    showMoreButton.disabled = true;
  } else {
    showMoreButton.classList.remove('ais-InfiniteHits-loadMore--disabled');
    showMoreButton.disabled = false;
  }

  // Define promo block HTML
  const promoData = window.collectionPromoBlock;

const promoHTML = promoData ? `
  <li class="ais-InfiniteHits-item promo-block">
    <div class="promo-content" style="border: 2px solid #F8F9FA; text-align: center;">
   <a href="${promoData.link}">   <img src="${promoData.image}" alt="Promo Banner" style="max-width: 100%; height: auto;
    height: 345px;
    object-fit: cover;" />
  <div class="promo-details">    <h3 style="margin: 0 0 5px;">${promoData.heading}</h3>
      <p style="margin: 0;">${promoData.text}</p></div>
    </div></a>
  </li>` : '';
     
const promoPosition = promoData && !isNaN(parseInt(promoData.position)) 
  ? parseInt(promoData.position) 
  : null;
     
  const hitsList = hits.map((hit, index) => {
    const isBestSeller = hit.tags && hit.tags.includes('Best Seller');
    const isSoldOut = hit.inventory_quantity <= 0 && !hit.available;
    const hasDiscount = hit.compare_at_price > hit.price;
    const discountPercentage = hasDiscount
      ? Math.round(((hit.compare_at_price - hit.price) / hit.compare_at_price) * 100)
      : 0;
    const productTitle = hit.meta?.smallflower?.product_title || hit.title || '';

    const productHTML = `
      <li class="ais-InfiniteHits-item">
        <div class="ais-hit ais-product" data-algolia-index="${hit.index}" data-algolia-position="${hit.productPosition}" data-algolia-queryid="${hit.queryID}" data-algolia-objectid="${hit.objectID}" data-handle="${hit.handle}" data-variant-id="${hit.objectID}" data-distinct="${hit._distinct}" data-product-id="${hit.id}" onClick="handleItemClick(event, ${hit})">
          <img class="ais-hit--picture" src="${algoliaShopify.helpers.mediumImage(hit)}" alt="${hit.title} - ${hit.variant_title}" />
          ${isBestSeller ? `
            <div class="product__itemlabel best-seller">
              <p class="ais-hit--tags">
                <img src="https://cdn.shopify.com/s/files/1/0418/0662/6967/files/best-seller_50x.png" srcset="https://cdn.shopify.com/s/files/1/0418/0662/6967/files/best-seller_100x.png 2x" loading="lazy" />
              </p>
            </div>` : ''}
          ${hasDiscount ? `
            <div class="product__itemlabel discount">
              <span class="discount-percentage">Save ${discountPercentage}%</span>
            </div>` : ''}
          ${isSoldOut && !hasDiscount ? `
            <div class="product__itemlabel sold-out">
              <span class="sold-out-text">Sold Out</span>
            </div>` : ''}
          <div class="ais-hit--details">
            <div class="product__vendor">${hit.vendor}</div>
            <p class="ais-hit--title">
              <a href="${algoliaShopify.helpers.instantsearchLink(hit)}" onclick="void(0)" title="${algoliaShopify.helpers.fullTitle(productTitle, hit._distinct, hit.variant_title)}">
                ${productTitle}
              </a>
            </p>
            ${isSoldOut ? `
              <p class="ais-hit--price out-of-stock-text">Out of stock</p>` : `
              <p class="ais-hit--price tt">
                <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>
                ${hasDiscount ? `
                  <span class="ais-hit--price-striked">
                    <span>${algoliaShopify.helpers.displayStrikedPrice(hit.price, hit.compare_at_price)}</span>
                  </span>` : ''}
                ${hasDiscount ? `
                  <span class="ais-hit--price-discount">
                    Save ${discountPercentage}%!
                  </span>` : ''}
                <button aria-label="Add to Wishlist" 
                  data-with-epi="true" 
                  class="swym-button swym-add-to-wishlist-view-product product_${hit.id}" 
                  data-swaction="addToWishlist" 
                  data-product-id="${hit.id}" 
                  data-variant-id="${hit.objectID}" 
                  data-product-url="${window.location.origin}/products/${hit.handle}">
                </button>
              </p>`}
          </div>
        </div>
      </li>
    `;

    // Insert promo block after 4th product
     if (promoPosition !== null && index === promoPosition) {
    return productHTML + promoHTML;
  }
    return productHTML;
  }).join('');

  container.querySelector('ol').innerHTML = hitsList;
};

    const customInfiniteHits = connectInfiniteHits(renderInfiniteHits);
    
    const infiniteHitsWidget = customInfiniteHits({
    container: document.querySelector('.ais-hits-container'),
    templates: {
    item(hit, { html, components }) {
      return html`${hit}`;
    },
    empty(results, { html }) {
      return window.algoliaShopify.instantsearch.templates.instantSearchNoResultTemplate(html, window.algoliaShopify);
    }
  },
  transformItems: items => {
    return items.map(item => ({
      ...item,
      _distinct: window.algoliaShopify.instantsearch.distinct,
      can_order: item.inventory_policy === 'continue' || item.inventory_quantity > 0,
      queryID: item.__queryID,
      productPosition: item.__position,
      index: window.algoliaShopify.instantsearch.search.mainIndex.getIndexName(),
    }));
  }
  });
    
    const hierarchicalMenus = hierarchicalMenu({
    container: '#aa-hierarchical-menu',
    attributes: [
      'named_tags.Category1',
      'named_tags.Category2',
      'named_tags.Category3',
    ],
    separator: ' / ',
    templates:{
      item(data,{html}){return html`
        <a class="${data.cssClasses.link}" href="${data.url}">
          <span class="${data.cssClasses.label} ais-facet--label">${data.label}</span>
          <span class="${data.cssClasses.count} ais-facet--count-distinct">
            ${data.count.toLocaleString()}
          </span>
        </a>
      `}}
  });

    
    return [infiniteHitsWidget, sortBY, hierarchicalMenus];
 });

  
});

